<template>
  <div class="auth">
    <div class="banner"></div>
    <div class="help"></div>
    <div class="main">
      <div class="logo"></div>
      <div class="title">Set New Password</div>

      <v-card flat="flat" class="card" :loading="loading">
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-text-field
              v-model="password"
              label="New  "
              type="password"
              :rules="passwordRules"
              required
            ></v-text-field>

            <v-text-field
              v-model="passwordConfirm"
              label="Confirm New Password"
              type="password"
              :rules="passwordRules"
              required
            ></v-text-field>

            <v-btn class="mt-3 btn-submit" color="#2bb9aa" @click="save"
              >SAVE</v-btn
            >
            <div class="mt-5"></div>
          </v-form>
        </v-card-text>
      </v-card>

      <div class="lang">
        <lang-select></lang-select>
      </div>
    </div>
    <div class="grey-background"></div>
  </div>
</template>

<script>
export default {
  created() {
    if (!this.$store.state.auth.reset_verified) {
      this.$router.push({ path: "/password-reset-request" });
    }
  },

  data: () => ({
    valid: false,
    loading: false,

    passwordRules: [
      v => !!v || "This field is Required",
      v =>
        /(?=.*[a-z])/.test(v) ||
        "Must contain at least 1 lowercase alphabetical character",
      v =>
        /(?=.*[A-Z])/.test(v) ||
        "Must contain at least 1 uppercase alphabetical character",
      v => /(?=.*[0-9])/.test(v) || "Must contain at least 1 numeric character",
      v =>
        /(?=.[!@#\$%\^&])/.test(v) ||
        "Must contain at least one special character",
      v => /(?=.{8,})/.test(v) || "Must be eight characters or longer"
    ],

    password: "",
    passwordConfirm: ""
  }),

  methods: {
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.password != this.passwordConfirm) {
        this.password = "";
        this.passwordConfirm = "";
        return;
      }

      this.loading = true;
      this.$store
        .dispatch("reset_new_password", {
          password: this.password
        })
        .then(() => {
          this.loading = false;
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          this.loading = false;

          this.password = "";
          this.passwordConfirm = "";
        });
    }
  }
};
</script>
